import React, { useCallback, useEffect, useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { getUploadList, moveFolder } from '@gtintel/platform-api';
import ModalIcon from '../../atoms/Icons/ModalIcon';
import { CustomAlert } from '../../atoms/Modal/Alert/styles';
import ModalIconSection from '../../atoms/Modal/IconSection';
import ModalTitle from '../../atoms/Modal/Title';
import { DOCUMENT_LIBRARY_CHAT_DIR } from '../../const';
import MoveFolderItem from './parts';
import { BackItem, FolderList } from './style';
export default function MoveModal({
  file,
  isVisible,
  projectId,
  refreshFileList,
  setIsVisible
}) {
  const [currentPath, setCurrentPath] = useState('');
  const [folders, setFolders] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [selectedPath, selectPath] = useState('');
  const [type, setType] = useState('');
  const fileOrFolder = file.extension === 'folder' ? 'folder' : 'file';

  // Load the folders that will be displayed in the modal.
  const loadFolders = useCallback(async path => {
    setIsLoading(true);
    let folders = await getUploadList({
      projectId,
      path
    });
    folders = folders.filter(({
      file,
      path
    }) => file === null && !path.startsWith(DOCUMENT_LIBRARY_CHAT_DIR));

    // This isn't ideal as we make a separate HTTP request for every folder
    // in the current dir, but I can't see another way to do it without major
    // changes to the backend.
    await Promise.all(folders.map(async folder => {
      const contents = await getUploadList({
        projectId,
        path: folder.path
      });
      folder.hasSubdirs = contents.some(({
        file
      }) => file === null);
    }));

    // We need to make all these state updates at once so the user
    // sees a smooth transition in the UI:
    setFolders(folders);
    setCurrentPath(path);
    selectPath(path);
    setIsLoading(false);
  }, [projectId]);
  useEffect(() => {
    if (!isVisible) return;
    loadFolders(currentPath);
  }, [loadFolders, isVisible, currentPath]);
  const setError = message => {
    setMsg(message);
    setType('error');
  };
  const closeModal = () => {
    setIsVisible(false);
    setMsg('');
    setType('');
    selectPath('');
    setCurrentPath('');
  };
  const handleOk = async () => {
    if (!selectedPath) {
      setError('You must select a destination folder');
      return;
    }
    try {
      await moveFolder({
        folder: file.path,
        project_id: projectId,
        new_path: selectedPath === '/' ? '' : selectedPath
      });
      setMsg('The ' + fileOrFolder + ' was moved successfully');
      setType('success');
      refreshFileList();
      closeModal();
    } catch (error) {
      if (error.data) {
        setError(error.data.message);
      }
    }
  };
  const back = () => {
    const depth = currentPath.split('/').length - 1;
    if (depth > 1) {
      const path = currentPath.slice(0, currentPath.slice(0, -1).lastIndexOf('/')) + '/';
      loadFolders(path);
    } else {
      loadFolders('');
    }
  };
  const selectionTxt = selectedPath === '/' ? selectedPath : selectedPath.replace(/\/$/, '');
  return <Modal visible={isVisible} closable keyboard onOk={handleOk} onCancel={closeModal} okText="Confirm" data-testid="doc-move-folder-modal">
      <ModalIconSection>
        <ModalIcon type="move" />
        <ModalTitle>
          Move {fileOrFolder} - {file.name}
        </ModalTitle>
        {selectedPath && <>
            <br />
            Move {fileOrFolder} to <strong>{selectionTxt}</strong>?
          </>}
      </ModalIconSection>
      {type && <CustomAlert message={msg} type={type} showIcon closable />}
      {currentPath !== '' && <BackItem>
          <Button type="text" onClick={back} disabled={isLoading}>
            <LeftOutlined /> Back
          </Button>
        </BackItem>}
      {folders && <FolderList>
          {currentPath === '' && <MoveFolderItem hasSubdirs={false} isLoading={isLoading} key="0" name="Root Folder" selectedPath={selectedPath} path="/" selectThisDir={() => selectPath('/')} />}
          {folders.map(folder => <MoveFolderItem hasSubdirs={folder.hasSubdirs} isLoading={isLoading} key={folder.path} name={folder.path.slice(0, -1).split('/').pop()} selectedPath={selectedPath} path={folder.path} selectThisDir={() => selectPath(folder.path)} expandThisDir={() => loadFolders(folder.path)} />)}
        </FolderList>}
    </Modal>;
}